<template>
  <a-modal 
    :title="modalTitle" 
    :visible="show" 
    @ok="ok" 
    @cancel="cancel" 
    :forceRender="true" 
    :destroyOnClose="true"
    :maskClosable="false" 
    width="600px" 
    okText="确定" 
    cancelText="取消"
    :centered="false"
    :style="{ top: '15%' }"
  >
    <template slot="footer">
      <a-space>
        <a-button @click="cancel">取消</a-button>
        <a-button :loading="saveLoading" type="primary" @click="ok">确定</a-button>
      </a-space>
    </template>
    
    <a-form-model 
      ref="ruleForm" 
      class="create-form" 
      :model="form" 
      :rules="rules" 
      :validateOnRuleChange="true"
      :label-col="{ span: 5 }" 
      :wrapper-col="{ span: 12 }"
    >
      <a-form-model-item label="配方名称" prop="formulaName">
        <a-input 
          placeholder="请输入配方名称" 
          v-model.trim="form.formulaName" 
          @input="checkNameLen"
        />
      </a-form-model-item>

      <a-form-model-item v-if="!isCopyMode" label="动物类型" prop="animalTypeCode">
        <a-cascader 
          ref="cascader" 
          :options="animal" 
          :load-data="loadAnimalData" 
          size="small" 
          placeholder="请选择动物类型" 
          v-model="formData.animal"
          @change="onAnimalChange"
        />
      </a-form-model-item>

      <a-form-model-item label="备注" prop="remark">
        <a-textarea 
          :maxLength="150" 
          v-model="form.remark" 
          placeholder="请输入备注信息" 
          :rows="3"
          :auto-size="{ minRows: 3, maxRows: 4 }" 
        />
        <div class="char-count">{{ form.remark ? form.remark.length : 0 }}/150</div>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { nhfMixins } from '../../untils';
import api from '../api';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // 新增props来控制模式
    mode: {
      type: String,
      default: 'create', // 'create' 或 'copy'
      validator: value => ['create', 'copy'].includes(value)
    },
    // 复制模式下的源数据
    copyData: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [nhfMixins],
  data() {
    return {
      saveLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      // 动物类型相关
      animal: [],
      formData: {
        animal: [],
      },
      deleteIds: [], // 用于过滤已删除的动物类型
      form: {
        formulaName: '',
        animalTypeCode: undefined,
        animalTypeName: '',
        remark: ''
      },
      rules: {
        formulaName: [
          { required: true, message: '请输入配方名称', trigger: 'change' },
          { validator: this.validatorName, trigger: 'change' }
        ],
        animalTypeCode: [
          { required: true, message: '请选择动物类型', trigger: 'change' }
        ]
      },
      maxLen: 31
    };
  },
  computed: {
    isCopyMode() {
      return this.mode === 'copy';
    },
    modalTitle() {
      return this.isCopyMode ? '复制配方' : '新建配方';
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.initForm();
        // 初始化动物类型数据
        this.initAnimal();
      }
    }
  },
  mounted() {
    this.factoryId = window.localStorage.getItem('factoryId');
  },
  methods: {
    // 初始化表单
    initForm() {
      if (this.isCopyMode && this.copyData) {
        // 复制模式：填充源数据
        this.form = {
          formulaName: this.copyData.formulaName + 'Copy' || '',
          animalTypeCode: undefined, // 先设置为 undefined
          animalTypeName: this.copyData.animalTypeName || '',
          remark: this.copyData.remark || ''
        };

        this.$nextTick(() => {
          this.form.animalTypeCode = this.copyData.animalTypeCode;
          // 设置 animal 变量，用于级联选择器
          this.formData.animal = this.copyData.animalTypeCode ? [this.copyData.animalTypeCode] : [];
        });
      } else {
        // 新建模式：清空表单
        this.cleanForm();
      }
    },

    /**
     * 配方名称验证
     * @param {Object} rule - 验证规则
     * @param {string} value - 输入的值
     * @param {Function} callback - 回调函数
     */
    validatorName(rule, value, callback) {
      let msg = '';
      // 特殊字符验证
      let reg2 = /[*[\]：？<>/、\\.]/im;
      if (reg2.test(value)) {
        msg = '配方名称不能包含*[]：？<>/、\\.等特殊字符';
      }
      // 长度验证
      let len = value.length;
      if (len > this.maxLen) {
        msg = `配方名称长度不能超过${this.maxLen}个字符`;
      }
      if (msg) callback(new Error(msg));
      callback();
    },

    /**
     * 配方名称长度检查
     * @param {Event} e - 输入事件
     */
    checkNameLen(e) {
      let val = e.target.value;
      let len = val.length;
      if (len > this.maxLen) {
        this.form.formulaName = val.substring(0, this.maxLen);
        this.$message.warning(`配方名称长度不能超过${this.maxLen}个字符`);
      }
    },

    /**
     * 动物类型选择变化
     * @param {Array} val - 选中的动物类型代码数组
     * @param {Array} select - 选中的选项数组
     */
    onAnimalChange(val, select) {
      this.animalChange(select, val);
    },

    /**
     * 动物类型变化处理
     * @param {Array} select - 选中的选项数组
     * @param {Array} val - 选中的值数组
     */
    animalChange(select, val) {
      if (val && val.length > 0) {
        if (val.length > 1) {
          const { name, id } = [...select].pop();
          const { id: animalRootId } = [...select].shift();
          this.form.animalTypeName = name;
          this.form.animalTypeCode = id;
          this.form.animalRootId = animalRootId;
        }
      } else {
        // 清空选择时
        this.form.animalTypeName = undefined;
        this.form.animalTypeCode = undefined;
        this.form.animalRootId = undefined;
      }
    },

    /**
     * 数据映射过滤器
     * @param {Object} i - 数据项
     * @returns {Object} 映射后的数据
     */
    mapFilter(i) {
      return {
        ...i,
        label: i.name,
        value: i.id,
        isLeaf: !i.hasChildren
      };
    },

    /**
     * 加载动物类型数据
     * @param {Array} selectedOptions - 已选择的选项
     */
    async loadAnimalData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      const { value: parentId } = targetOption;
      let factoryId = window.localStorage.getItem('factoryId');
      const res = await this.animalTypeList({ parentId, factoryId });
      targetOption.loading = false;
      res.data = res.data.filter(el => !this.deleteIds.includes(el.id));
      targetOption.children = res.data.map(this.mapFilter);
      this.animal = [...this.animal];
    },

    /**
     * 初始化动物类型
     */
    async initAnimal() {
      let factoryId = window.localStorage.getItem('factoryId');
      const res = await this.animalTypeList({ parentId: 0, factoryId });
      const { data } = res;
      if (data && data.length && data[0].id) {
        const resAnimal = await this.animalTypeList({ parentId: data[0].id, factoryId });
        this.animal = resAnimal.data.map(this.mapFilter);
      } else {
        this.animal = res.data.map(this.mapFilter);
      }
    },

    /**
     * 确定按钮点击事件
     * 根据模式（新建或复制）提交表单数据
     */
    ok() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true;
          try {
            const submitData = {
              formulaName: this.form.formulaName.trim(),
              remark: this.form.remark
            };
            let res = null;
            if (this.isCopyMode) {
              // 复制模式：添加被复制配方的ID和factoryId
              submitData.id = this.copyData.id;
              submitData.factoryId = this.factoryId;
              res = await api.copyOEMFormula(submitData);
            } else {
              submitData.animalTypeCode = this.form.animalTypeCode;
              submitData.animalTypeName = this.form.animalTypeName;
              submitData.factoryId = this.factoryId;
              // 新建模式
              res = await api.saveOEMFormula(submitData);
            }

            if (res.success) {
              this.cleanForm();
              this.$emit('close', true);
            }
          } catch (error) {
            console.error(this.isCopyMode ? '复制配方失败:' : '新建配方失败:', error);
            this.$message.error(this.isCopyMode ? '复制失败，请重试' : '新建失败，请重试');
          } finally {
            this.saveLoading = false;
          }
        }
      });
    },

    /**
     * 取消按钮点击事件
     * 清空表单并关闭模态框
     */
    cancel() {
      this.cleanForm();
      this.$emit('close', false);
    },

    /**
     * 清空表单
     * 重置表单字段并初始化表单数据
     */
    cleanForm() {
      this.$refs.ruleForm.resetFields();
      this.formData.animal = [];
      this.form = {
        formulaName: '',
        animalTypeCode: undefined,
        animalTypeName: '',
        remark: ''
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.create-form {
  padding: 8px 0;
}

::v-deep .ant-form-item {
  margin-bottom: 16px;
}

::v-deep .ant-form-item-label > label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

::v-deep .ant-form-item-label > label::before {
  content: '';
  display: inline-block;
  margin-right: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
}

::v-deep .ant-form-item-label > label.ant-form-item-required::before {
  content: '*';
}

::v-deep .ant-input,
::v-deep .ant-cascader-picker,
::v-deep .ant-textarea {
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  transition: all 0.3s;
  
  &:hover {
    border-color: #40a9ff;
  }
  
  &:focus {
    border-color: #1890ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
}

::v-deep .ant-modal-header {
  border-bottom: 1px solid #e8e8e8;
  padding: 16px 24px;
}

::v-deep .ant-modal-title {
  font-weight: 600;
  color: #444;
  font-size: 16px;
}

::v-deep .ant-modal-body {
  padding: 24px;
}

::v-deep .ant-modal-footer {
  border-top: 1px solid #e8e8e8;
  padding: 16px 24px;
}

.char-count {
  text-align: right;
  color: #8c8c8c;
  font-size: 12px;
  margin-top: 4px;
  line-height: 1;
}

// 按钮样式优化
::v-deep .ant-btn {
  border-radius: 4px;
  font-weight: 500;
  height: 32px;
  padding: 0 16px;
  
  &.ant-btn-primary {
    background: #1890ff;
    border-color: #1890ff;
    
    &:hover {
      background: #40a9ff;
      border-color: #40a9ff;
    }
  }
}
</style>